export default "__VITE_ASSET__DPoCnSs2__"